<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 3.36387L16.6361 2.5L9.96073 9.17539L3.36387 2.5L2.5 3.36387L9.17539 9.96073L2.5 16.6361L3.36387 17.5L9.96073 10.8246L16.6361 17.5L17.5 16.6361L10.8246 9.96073L17.5 3.36387Z" fill="#E2E2E2"/>
</svg>
